import {FileDetails} from './file-details';
import {Optional} from 'typescript-optional';

export class FilesDetailsRequest {
  fileUploadRequestList: FileDetails[];
  
  
  constructor() {
    this.fileUploadRequestList = [];
  }
  
  from(detailsList: FileDetails[]) {
    this.fileUploadRequestList = Optional.ofNullable(detailsList).orElse([]);
  }
  
  addFileDetail(fileDetails: FileDetails): FilesDetailsRequest {
    if (!this.fileUploadRequestList) { this.fileUploadRequestList = []; }
    this.fileUploadRequestList.push(fileDetails);
    return this;
  }
}
